export default "__VITE_ASSET__3db91347__"